import React, { useEffect, useReducer, useState, useCallback } from 'react';
import * as actions from '../../../actions/siteDetails';
import upcomingEventReducer from '../../../reducers/upcomingEvent';
import ScrollView from 'devextreme-react/scroll-view';
import moment from 'moment';

const initialState = { calendarUpcomingEventInfo: [] }

export default (props) => {
    const { site } = props;
    const [animate, setAnimate] = useState('');
    const [state, dispatch] = useReducer(upcomingEventReducer, initialState);
    useEffect(() => {
        if (site) {
            actions.fetchCalendarUpcomingEvent(dispatch, site);
        }
    }, [site]);
    const { calendarUpcomingEventInfo } = state;

    useEffect(() => {
        setTimeout(() => {
            setAnimate('animate')
        }, 250);
    }, []);
    return (
        <>
            {
                calendarUpcomingEventInfo && calendarUpcomingEventInfo.length > 0 &&
                <div className={"card calendar " + animate} style={{ "flex-direction": "column" }}>
                    <div style={{ "margin": "10px" }}> <h3 style={{ "fontWeight": "bold" }}>Upcoming Events</h3></div>
                    <div>
                        <ScrollView id="sitecontent"
                            {...{
                                showScrollbar: 'always',
                                scrollByContent: true,
                                scrollByThumb: true,
                            }}
                        >
                            <div className="posts-scroll-view">
                                {
                                    calendarUpcomingEventInfo && calendarUpcomingEventInfo.length > 0 && calendarUpcomingEventInfo.map((calendarData, i) =>
                                        <div key={i} className={"card calendar " + animate}>
                                            <div className="img-wrap">
                                                <div className="icon color-line" style={{ "width": "20px", "border-left": `6px solid ${calendarData.color}`, "height": "90%" }}></div>
                                            </div>
                                            <div className="slider-wrap" style={{ "fontSize": "16px", "textOverflow": "ellipsis", "whiteSpace": "nowrap", "overflow": "hidden", "display": "block" }}>
                                                <div id="event" style={{ "margin-bottom": "-10px" }}>
                                                    <label style={{ "fontSize": "18px", "textOverflow": "ellipsis", "whiteSpace": "nowrap", "overflow": "hidden" }}> {`${calendarData.text}`} </label>
                                                </div>
                                                <div id="event" style={{ "margin-bottom": "-10px" }}>
                                                    <label style={{ "fontWeight": "400", "fontSize": "15px", "textOverflow": "ellipsis", "whiteSpace": "nowrap", "overflow": "hidden" }}> {`${calendarData.location}`} </label>
                                                </div>
                                                <div id="event" style={{ "margin-bottom": "-10px" }}>
                                                    {
                                                        calendarData.location === 'Action Rail'
                                                            ?
                                                            <label style={{ "fontWeight": "400", "fontSize": "15px", "textOverflow": "ellipsis", "whiteSpace": "nowrap", "overflow": "hidden" }}>
                                                                {`${moment(new Date(calendarData.endDate + ' UTC')).format('MMM DD, LT')} `}
                                                            </label>
                                                            :
                                                            <label style={{ "fontWeight": "400", "fontSize": "15px", "textOverflow": "ellipsis", "whiteSpace": "nowrap", "overflow": "hidden" }}>
                                                                {`${moment(new Date(calendarData.startDate + ' UTC')).format('MMM DD, LT')} - ${moment(new Date(calendarData.endDate + ' UTC')).format('MMM DD, LT')} `}
                                                            </label>
                                                    }
                                                </div>
                                            </div>
                                        </div>
                                    )
                                }
                            </div>
                        </ScrollView>
                    </div>
                </div>
            }
        </>
    )
}